import axios from "axios";
import instance, { baseURL } from "../utils/apiUtils";

export const loginUser = async (credentials) => {
  try {
    const response = await axios.post(
      `${baseURL}api/authenticate`,
      credentials
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const registerUser = async (userData) => {
  try {
    const response = await instance.post("/api/register", userData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const createUser = async (userData) => {
  try {
    const response = await instance.post("/api/admin/users", userData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const activateAccount = async (key) => {
  try {
    const response = await axios.get(`${baseURL}api/activate?key=${key}`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const changePassword = async (currentPassword, newPassword) => {
  try {
    const response = await instance.post("api/account/change-password", {
      currentPassword,
      newPassword,
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getAllUsers = async (page = 0) => {
  try {
    const response = await instance.get(`api/admin/users?size=10&page=${page}`);
    const totalCount = parseInt(response.headers["x-total-count"]);
    const data = response.data;

    return { totalCount, data };
  } catch (error) {
    throw error.response.data;
  }
};

export const updateUser = async (user) => {
  try {
    const response = await instance.put(`api/admin/users`, user);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const toggleUserActivation = async (activationKey) => {
  try {
    const response = await instance.get(`api/activate?key=${activationKey}`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getUserById = async (userId) => {
  try {
    const response = await instance.get(`api/users/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getUserByName = async (username) => {
  try {
    const response = await instance.get(`api/admin/users/${username}`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getAccount = async () => {
  try {
    const response = await instance.get(`api/account`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
